export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7293.ee61c37a.jpg";